import { useEffect, type RefObject } from "react";

import { useAssistant } from "../assistant/AssistantContext";

/** Tastatureingabe gehört dem Feld: input, textarea, select, contenteditable. */
export function istEingabe(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName)) return true;
  // isContentEditable fehlt in manchen Umgebungen (jsdom); das Attribut gilt immer.
  return target.isContentEditable || target.closest('[contenteditable]:not([contenteditable="false"])') !== null;
}

/**
 * ⌘K / Strg+K fokussiert die Frageleiste im Briefing, sonst öffnet es die Hilfe.
 */
export function useAssistentTaste(inputRef?: RefObject<HTMLInputElement>): void {
  const assistant = useAssistant();
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      // Beim Tippen bleibt ⌘K beim Eingabefeld (wie bei den Tasten 1, 2, 3).
      if (istEingabe(event.target)) return;
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        if (inputRef) inputRef.current?.focus();
        else assistant.open();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [assistant, inputRef]);
}
